/* EmojiButton.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./EmojiButton.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { ResourcedEmoji } from '@atlaskit/emoji';
import { messages } from '../shared/i18n';
import { isLeftClick } from '../shared/utils';
import { RESOURCED_EMOJI_COMPACT_HEIGHT } from '../shared/constants';
import { Pressable } from '@atlaskit/primitives/compiled';
var styles = {
  emojiButton: "_12ji1r31 _1qu2glyw _12y31o36 _2rkoglpi _189eidpf _1e0c1txw _bfhksm61 _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _o7ksrkh3 _1llw1q5f",
  hoverableReactionPickerSelectorEmojiButton: "_12ji1r31 _1qu2glyw _12y31o36 _2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _8hrz1nam _ca0qv77o _u5f31b66 _n3td1b66 _19bv1b66 _bfhksm61 _syaz1gjq _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _irr3166n _1di61dty"
};
export var RENDER_BUTTON_TESTID = 'button-emoji-id';
/**
 * custom button to render the custom emoji selector inside the reaction picker
 */
export var EmojiButton = function EmojiButton(_ref) {
  var emojiId = _ref.emojiId,
    onClick = _ref.onClick,
    emojiProvider = _ref.emojiProvider,
    hoverableReactionPickerSelectorEmoji = _ref.hoverableReactionPickerSelectorEmoji;
  var onButtonClick = function onButtonClick(event) {
    event.preventDefault();
    if (onClick && isLeftClick(event)) {
      onClick(emojiId, undefined, event);
    }
  };
  var intl = useIntl();
  return /*#__PURE__*/React.createElement(Pressable, {
    testId: RENDER_BUTTON_TESTID,
    onClick: onButtonClick,
    "aria-label": intl.formatMessage(messages.reactWithEmoji, {
      emoji: emojiId.shortName
    }),
    xcss: hoverableReactionPickerSelectorEmoji ? styles.hoverableReactionPickerSelectorEmojiButton : styles.emojiButton
  }, /*#__PURE__*/React.createElement(ResourcedEmoji, {
    emojiProvider: emojiProvider,
    emojiId: emojiId,
    fitToHeight: hoverableReactionPickerSelectorEmoji ? RESOURCED_EMOJI_COMPACT_HEIGHT : undefined
  }));
};